import { FormField } from '../../fields/formField';
import { SelectField } from '../../fields/selectField';
import { TextField } from '../../fields/textField';
import { FormGroup } from '../../formGroup';
import { ConnectionRulesType } from '../../shared/connectionRulesType';
import { WithOptional } from '../../utility';

type ConfigProps = WithOptional<ZerezIdAndNormFormGroup, keyof FormGroup>;

export class ZerezIdAndNormFormGroup extends FormGroup {
    public readonly zerezId: SelectField<string>;
    public readonly norm: FormField<ConnectionRulesType[]>;
    public readonly normText: TextField;

    public constructor(config: ConfigProps) {
        super(config);

        this.zerezId = config.zerezId;
        this.norm = config.norm;
        this.normText = config.normText;
    }
}
